import { render } from "./RiderProfilePage.vue?vue&type=template&id=3b6fa160&scoped=true"
import script from "./RiderProfilePage.vue?vue&type=script&lang=ts"
export * from "./RiderProfilePage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3b6fa160"

export default script